import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';
import type { PresetMode } from '../..';
import darkDataZoomHandler from '../../../assets/ainvestDarkDataZoomHandler.png';
import lightDataZoomHandler from '../../../assets/ainvestLightDataZoomHandler.png';

const ainvestSliderStyle = {
  light: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fillerColor: 'rgba(0, 0, 0, 0.6)',
    handleIcon: `image://${lightDataZoomHandler as string}`
  },
  dark: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    fillerColor: 'rgba(255, 255, 255, 0.6)',
    handleIcon: `image://${darkDataZoomHandler as string}`
  }
};

function preprocessDataZoom(option: Parameters<ThemeParser>[0]) {
  option.dataZoom = normalizeToArray(option.dataZoom);
}

function parseDataZoom(option: Parameters<ThemeParser>[0], themeMode: PresetMode) {
  const dataZoomInside = {
    type: 'inside',
    start: 0,
    end: 100,
    orient: 'horizontal'
  };
  const defaultSliderStyle = {
    type: 'slider',
    /**
     * @description 因为设计师要求datazoom默认紧跟图表，但是datazoom定位是依靠绝对定位的，所以主题中暂时使用固定数值
     * @description 200: 默认图表高度
     */
    top: 200,
    /**
     * @description 15: 设计师根据最终效果调试datazoom左侧滑块的偏移
     * @description -15: 设计师根据最终效果调试datazoom右侧滑块的偏移
     */
    // eslint-disable-next-line no-magic-numbers
    dvHandleOffset: [15, -15],
    moveHandleIcon: 'path://',
    dvMoveHandleOffset: 24,
    borderRadius: 4,
    handleIcon: ainvestSliderStyle[themeMode].handleIcon,
    handleSize: 44,
    fillerColor: ainvestSliderStyle[themeMode].fillerColor,
    borderColor: 'transparent',
    left: 16,
    right: 16,
    showDataShadow: false,
    moveHandleSize: 48,
    moveHandleStyle: {
      color: 'transparent',
      opacity: 0
    },
    emphasis: {
      moveHandleStyle: {
        color: 'transparent',
        opacity: 0
      }
    },
    height: 4,
    backgroundColor: ainvestSliderStyle[themeMode].backgroundColor,
    showDetail: false
  };

  (option.dataZoom as unknown as []).forEach((datazoomOption, index) => {
    if (datazoomOption.type === 'slider' || !datazoomOption.type) {
      option.dataZoom[index] = util.merge(util.clone(defaultSliderStyle), datazoomOption, true);
    } else {
      option.dataZoom[index] = util.merge(util.clone(dataZoomInside), datazoomOption, true);
    }
  });
}

export function dataZoomThemeParse(...args: Parameters<ThemeParser>) {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  preprocessDataZoom(option);
  parseDataZoom(option, themeMode);
}
